import React from "react";
import { _getTranslation } from "../utils/helper";

const InputSearch = ({
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyUp,
  ...props
}) => {
  return (
    <input
      type="text"
      className={`search ${props.class ?? ""}`}
      placeholder={placeholder || _getTranslation("search")}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyUp={onKeyUp}
    />
  );
};

export default InputSearch;
